import React, { useState } from 'react';
import styled from '@emotion/styled';
import { LinkText } from 'views/components/molecules/LinkText';
import { Banner } from 'views/components/molecules/Banner';
import { LoginForm } from 'views/components/organisms/LoginForm';
import { Button } from 'views/components/atoms/Button';
import loginImage from 'views/layouts/LoginPageLayout/images/login.png';
import { Spacer } from 'views/components/atoms/Spacer';
import { FormattedMessage } from 'react-intl';
import { localeIds } from 'locals';
import { ROUTER_PATH, WEBFRONT_PATH } from 'views/constants';
import { APIDomain } from 'models/API';

const OauthButtonArea = styled.div(`
  display: ${({ hidden }: OauthButtonAreaProps): string =>
    hidden ? 'none' : 'block'};
  margin: auto;
  width: 288px;
  margin-top: 16px;
`);

type OauthButtonAreaProps = {
  hidden: boolean;
};

type LoginPageLayoutProps = {
  defaultEmail?: string;
  errorMessage?: string;
  onLogin(email: string, password: string): void;
  onGoogleLogin(): void;
  onGitHubLogin(): void;
};

export const LoginPageLayout: React.FC<LoginPageLayoutProps> = ({
  defaultEmail,
  errorMessage,
  onLogin,
  onGoogleLogin,
  onGitHubLogin,
}) => {
  const [hidden, setHidden] = useState(true);

  return (
    <>
      <Banner src={loginImage} />
      <LoginForm
        defaultEmail={defaultEmail}
        errorMessage={errorMessage}
        onLogin={onLogin}
      />

      <Spacer size="large" />

      <LinkText
        to="#"
        onClick={(): void => {
          setHidden(!hidden);
        }}
      >
        <FormattedMessage id={localeIds.loginPageLayout.oAuthLogin.linkTitle} />
      </LinkText>
      <OauthButtonArea hidden={hidden}>
        <Button type="button" onClick={onGitHubLogin}>
          <FormattedMessage id={localeIds.loginPageLayout.oAuthLogin.github} />
        </Button>
        <Spacer />
        <Button type="button" onClick={onGoogleLogin}>
          <FormattedMessage id={localeIds.loginPageLayout.oAuthLogin.google} />
        </Button>
      </OauthButtonArea>
      <Spacer />
      <LinkText to={ROUTER_PATH.samlLogin}>
        <FormattedMessage id={localeIds.loginPageLayout.SAML} />
      </LinkText>

      <Spacer size="large" />

      <LinkText to={ROUTER_PATH.signUp}>
        <FormattedMessage id={localeIds.loginPageLayout.signup} />
      </LinkText>
      <Spacer />
      <LinkText to={APIDomain.path(WEBFRONT_PATH.reset_password)}>
        <FormattedMessage id={localeIds.loginPageLayout.reminder} />
      </LinkText>
    </>
  );
};
